module.exports = __webpack_public_path__ + "img/CNMC-logo-sede.05e693b3.png";